(function () {
    'use strict';

    angular.module("imApp").factory("discGrpDatasService", [function () {
        let service = {};

        return service;
    }]);
})();
